<button
  hlmBtn
  variant="outline"
  type="button"
  [hlmDropdownMenuTrigger]="methods"
  align="end"
  [style.position]="menuOpen() ? 'relative' : null"
  [style.z-index]="menuOpen() ? 1000 : null"
  (hlmDropdownMenuOpened)="showBackdrop()"
  (hlmDropdownMenuClosed)="hideBackdrop()"
  data-cy="add-part-button">
  {{ 'part.addTitle' | translate }}
</button>

<ng-template #methods>
  <hlm-dropdown-menu class="w-80" [attr.aria-label]="'part.createMethodTitle' | translate" data-cy="add-part-methods">
    <a hlmDropdownMenuItem routerLink="/add/import" class="flex-col items-start gap-0.5 px-2 py-2" data-cy="create-method-import">
      <span class="text-sm font-medium">{{ 'part.importFromFile' | translate }}</span>
      <span class="text-muted-foreground text-sm">{{ 'part.importFromFileDescription' | translate }}</span>
    </a>
    <a hlmDropdownMenuItem routerLink="/add/manual" class="flex-col items-start gap-0.5 px-2 py-2" data-cy="create-method-manual">
      <span class="text-sm font-medium">{{ 'part.manualEntry' | translate }}</span>
      <span class="text-muted-foreground text-sm">{{ 'part.manualEntryDescription' | translate }}</span>
    </a>
  </hlm-dropdown-menu>
</ng-template>
